export default function () {
  const widgetName = 'cardwidgetevents';
  // eslint-disable-next-line no-undef
  const widgetOpts = cardWidgetEventsOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
    },
    cardWidgetLoaded: function (data) {
      $(`#${widgetName} .card-widget-item .card-content`).each(function (i) {
        $(`#${widgetName} .card-widget-item.void-link`).removeAttr('href');

        if (data.items[i].DateRange) {
          let rawDate = data.items[i].DateRange.slice(0, 7);
          let m = rawDate.slice(0, 4).trim();
          let d = rawDate.replace(',', '').slice(-3).trim();
          let dateHTML = `
            <div class="card-widget-date">
              <span>${m}</span>
              <span>${d}</span>
            </div>
          `;
          $(this).prepend(dateHTML);
        }
        // Add variable for the limit Title
        const titleLimit = 45;
        const titleElement = $(this).find('.card-widget-title');
        const titleText = titleElement.text();
        if (titleText.length > titleLimit) {
          const truncatedText = titleText.substring(0, titleLimit) + '...';
          titleElement.text(truncatedText);
        }
      });
    },
    itemsPerPanel: 5,
    maxItemsVisible: 5,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    moreButton: {
      visible: false,
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: true,
  });
}
